import {css} from "lit";

export const annotationDragStyles = css`
	#container {
		box-sizing: border-box;
		display: inline-flex;
		justify-content: center;
		align-items: flex-start;
		flex-shrink: 0;
		gap: 9px;
		padding: 8px 10px;

		min-height: 40px;
		max-height: 65px;
		max-width: 500px;

		overflow: hidden;
		user-select: none;

		border-radius: 10px;
		border: 1px solid var(--PN-Purple-500, #9542FF);
		background: white;
		transform: rotate(-3.25deg);
		opacity: 0.9;

		box-shadow: 10px 14px 64px 0px rgba(0, 0, 0, 0.10);
	}

	#logo {
		width: 20px;
		height: 24px;
		align-self: center;
	}

	#container[data-type="image"] {
		display: block;
		height: 120px;
		width: 120px;
		max-height: 200px;
	}

	[data-type="image"] #logo {
		display: none;
	}

	[data-type="image"] #content {
		height: 100px;
		width: 100px;
		margin: auto;
	}

	[data-type="image"] #content img {
		height: inherit;
		width: inherit;
	}

	#content * {
		margin: 0;
	}
`;
